import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { OverlayTrigger, Spinner, Icon, IfPermitted } from "components/common";
import {
  useDetectionChainEventDefinitionSummary,
  useDetectionChainEvents
} from "security-app/hooks/useSecurityEventsAPI";
import { useModalContext } from "common/contexts";
import { Row, Col, Badge } from "common/components";
const StyledIcon = styled(Icon)`
  color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.disabled : theme.colors.text.primary};
`;
const Title = styled.span`
  color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.disabled : theme.colors.text.primary};
`;
const Note = styled.span`
  margin-top: ${({ theme }) => theme.spacings.sm};
  color: ${({ theme }) => theme.colors.text.disabled};
`;
function WidgetTitle({ dcId }) {
  const { setModal, setEntity } = useModalContext();
  const { detectionChainEvents, loadingDetectionChainEvents } = useDetectionChainEvents(dcId);
  const openEvidenceModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { event_ids } = detectionChainEvents;
    setEntity(event_ids);
    setModal("ADD-EVIDENCE");
  };
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "space-between" }, /* @__PURE__ */ React.createElement("span", null, "Detection Chain Rules"), loadingDetectionChainEvents ? /* @__PURE__ */ React.createElement(Spinner, { text: "Loading associated events" }) : /* @__PURE__ */ React.createElement(Row, { $align: "center", $justify: "flex-end", $width: "auto", $gap: "md" }, /* @__PURE__ */ React.createElement("small", null, "Associated events count", " ", /* @__PURE__ */ React.createElement(Badge, { variant: "info", size: "sm" }, detectionChainEvents.event_count)), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["security_event:edit", "*"] }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "primary", onClick: openEvidenceModal }, "Add events to an investigation"))));
}
function DetectionChainDetails({ chainRules }) {
  return /* @__PURE__ */ React.createElement(Col, null, chainRules.map((rule) => /* @__PURE__ */ React.createElement(Row, { key: rule.id, $gap: "sm", $align: "center" }, /* @__PURE__ */ React.createElement(StyledIcon, { name: rule.seen ? "task" : "scan_delete", size: "sm", $disabled: !rule.seen }), /* @__PURE__ */ React.createElement(Title, { $disabled: !rule.seen }, rule.title))), /* @__PURE__ */ React.createElement(Note, null, /* @__PURE__ */ React.createElement("i", null, "*Note: Grayed out rules have not been detected in your data")));
}
function DetectionChain({ eventId }) {
  const { detectionChain, loadingDetectionChain } = useDetectionChainEventDefinitionSummary(eventId);
  if (loadingDetectionChain) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Detection Chain details" });
  return /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      trigger: "click",
      rootClose: true,
      placement: "right",
      overlay: /* @__PURE__ */ React.createElement(DetectionChainDetails, { chainRules: detectionChain.rules }),
      title: /* @__PURE__ */ React.createElement(WidgetTitle, { dcId: detectionChain.id }),
      width: 800
    },
    /* @__PURE__ */ React.createElement(Row, { $gap: "xxs", $align: "center" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link" }, /* @__PURE__ */ React.createElement("strong", null, detectionChain.title)), /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right", size: "sm" }))
  );
}
export default DetectionChain;
